<template>
  <ZMainPage type="card">
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text">报名信息</span>
      </div>
      <DynamicForm ref="dynamicDom" :list="formConfig" labelWidth="165rem"></DynamicForm>
    </div>
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text">缴费信息</span>
      </div>
      <el-form ref="form" :model="formData" :rules="rules" label-width="160rem">
        <el-row>
          <el-col span="8">
            <el-form-item label="应缴金额" prop="payment_amount">
              <el-input v-model="formData.payment_amount" placeholder="请输入实缴金额"></el-input>
              <div class="tips-info"><i class="el-icon-info"></i>仅填写学费及杂费部分，请勿填写分差费！</div>
            </el-form-item>
          </el-col>
          <el-col span="8">
            <el-form-item label="缴费时间" prop="pay_time">
              <el-date-picker v-model="formData.pay_time" type="datetime" placeholder="请选择缴费时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col span="21">
            <el-form-item label="备注">
              <el-input type="textarea" v-model="formData.remarks" placeholder="请填写学生情况或所参与的优惠政策" :autosize="{ minRows: 4, maxRows: 8}" :maxlength="100" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <template #footer>
      <el-button type="primary" v-if="isDetail" @click="handleBack">返回</el-button>
      <template v-else>
        <el-button type="primary" @click="handleSubmit">提交</el-button>
        <el-button @click="handleBack">返回</el-button>
      </template>
    </template>
  </ZMainPage>
</template>
<script>
import DynamicForm from '@/components/common/DynamicForm'
import http, { changeObjToArr } from '@/api'
import { setConfigOption, changeOption } from '@/utils'
import { validateIdCard, validatePassport, validateNumber } from '@/utils/validate'
export default {
  _config: {'route': {'path': 'add', 'meta': {'title': '新增'}}},
  components: { DynamicForm },
  data() {
    return {
      formConfig: [],
      formData: {
        document_type: 1,
        payment_amount: '',
        pay_time: '',
        remarks: ''
      },
      rules: {
        payment_amount: [ {required: true, trigger: 'change', validator: (_r, value, callback) => validateNumber(value, callback, { min: 0, equalToMin: true }) }],
        pay_time: [ {required: true, message: '请选择缴费时间', trigger: 'change'}]
      },
      // dialogVisible: false
    }
  },
  created() {
    this.getData()
  },
  methods: {
    changeCertificateType(e) {
      this.formData.document_type = e
      this.$refs.dynamicDom.validateField('student_idcard')
    },
    getData() {
      const year = new Date().getFullYear()
      const validateCheck = (_r, value, callback) => {
        if (this.formData.document_type === 1) {
          validateIdCard(value, callback)
        } else if(this.formData.document_type === 2) {
          validatePassport(value, callback)
        }
      }
      this.formConfig = [
        { label: '报名校区', prop: 'school_id', tag: 'select', value: '', span: 8, options: [], rules: [{required: true, message: '请选择报名校区', trigger: 'change'}] },
        { label: '入学年级', prop: 'grade_id', tag: 'select', value: '', span: 8, options: [], rules: [{required: true, message: '请选择入学年级', trigger: 'change'}] },
        { label: '入学年份', prop: 'grade_year', tag: 'select', value: year, span: 8, options: [], rules: [{required: true, message: '请选择入学年份', trigger: 'change'}] },

        { label: '学生姓名', prop: 'student_name', maxlength: 30, value: '', span: 8, rules: [{required: true, message: '请输入学生姓名', trigger: 'change'}] },
        { label: '学生证件类型', prop: 'document_type', tag: 'select', value: 1, span: 8, options: [{ label: '身份证', value: 1 }, { label: '护照', value: 2 }], change: this.changeCertificateType, rules: [{required: true, message: '请选择证件类型', trigger: 'change'}] },
        { label: '学生身份证号', prop: 'student_idcard',  value: '', span: 8, maxlength: 18, rules: [{ required: true, validator: validateCheck, trigger: 'change'}], isClear: true, vPlaceholder: [{ key: 'document_type', value: 1, symbol: '=', change: '学生身份证号'}, { key: 'document_type', value: 2, symbol: '=', change: '学生护照号' }] },

        { label: '学生类型', prop: 'student_type', tag: 'select', value: '', span: 8, options: [], rules: [{required: true, message: '请选择学生类型', trigger: 'change'}] },
        { label: '所属业务线', prop: 'business_line', tag: 'select', value: '', placeholder: '请先选择学生类型', span: 8, options: [], rules: [{required: true, message: '请选择所属业务线', trigger: 'change'}] },
      ]
      this.getConfig()
    },
    getConfig() {
      http({ url: '/recruit-v2/offline-fresh/config', pre: 'zs' }).then(res => {
        const { school_data, grade_add, grade_year_add, student_type_list, business_line_list } = res
        setConfigOption({ list: this.formConfig, data: school_data, key: 'school_id', label: 'school_name', value: 'school_id' })
        setConfigOption({ list: this.formConfig, data: grade_add, key: 'grade_id', label: 'grade_name', value: 'grade_id' })
        setConfigOption({ list: this.formConfig, data: changeObjToArr(grade_year_add), key: 'grade_year' })
        setConfigOption({ list: this.formConfig, data: student_type_list, key: 'student_type', label: 'student_type_name', value: 'student_type' })
        const businessList = changeOption({ list: business_line_list, key: 'business_line', label: 'business_line_name', value: 'business_line' }).map(i => {
          const obj = { ...i }
          obj.vIf = [2,5].includes(i.value) ? [{ key: 'student_type', value: 2 }] : [{ key: 'student_type', value: 1 }, { key: 'student_type', value: 3 }]
          return obj
        })
        setConfigOption({ list: this.formConfig, data: businessList, key: 'business_line' })
      })
    },
    handleSubmit() {
      this.$refs.dynamicDom.validate().then((form) => {
        this.$refs.form.validate(val => {
          if (val) {
            const data = { ...this.formData, ...form }
            this.$confirm(`是否确认【${data.student_name}】已缴纳学费，提交后财务通过审批学生即可报名成功`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '再看看',
              type: 'warning',
              center: true
            }).then(() => {
              this.onSubmit(data)
            })
          }
        })
      }).catch(() => {
        this.$refs.form.validate()
      })
    },
    onSubmit(data) {
      http({ url: '/recruit-v2/offline-fresh/add-v2', pre: 'zs', method: 'post' }, data, { origin: true, loading: true }).then(res => {
        const { status, msg } = res;
        if (status) {
          return this.$alert(msg, {
            dangerouslyUseHTMLString: true,
            center: true
          })
        }
        this.$message.success('添加成功')
        this.$router.back()
      }).catch(err => {})
    },
    handleBack() {
      this.$confirm('页面内容尚未保存, 是否继续返回?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.back()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.tips-info {
  margin-top: 16rem;
  padding: 4rem 10rem;
  font-size: 12rem;
  line-height: 20rem;
  color: #999;
  background-color: #f5f5f5;
  display: inline-block;
  border-radius: 6rem;
  .el-icon-info {
    margin-right: 6rem;
  }
}
</style>
